import generateLinkTag from "./generate_cookieconsent_compliant_link_tag";

generateLinkTag({
  url: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap",
});
